<template>
  <div id="app" :style="{height:`${innerHeight}px`}"
  >
    <transition name="fade-transform" mode="out-in">
      <component
          :is="currentComponent"
          :type="type"
          :payToken="payToken"
          :isWalletPayment="isWalletPayment"
          :payChannelID="payChannelID"
          @goTo="handleGoTo"
          @paymentTypeChanged="paymentTypeChanged"
          :payUrl="payUrl"
      />
    </transition>
  </div>
</template>

<script>
import PaymentSelectList from '@/pages/PaymentSelectList'
import Result from '@/pages/Result'
import { getSearchParams } from '@/utils'
import { getRegionInfo, queryPay } from '@/api'
import { setCurrencyInfo, setLocale, getLocale } from '@/utils/localstorage-provider'
import sa from 'sa-sdk-javascript'
import { saUrl } from '@/const/sa-url'
import { country2DCString } from '@/utils/country2DCString'
import { mapGetters } from 'vuex'
import { types, postMessage } from '@hll/cashier-kit'

const nameKey = 'windowDotName'
export default {
  name: 'App',
  components: {
    PaymentSelectList,
    Result,
    Adyen: () => import(/* webpackChunkName: "Adyen" */'@/pages/Adyen'),
    Tappay: () => import(/* webpackChunkName: "Tappay" */'@/pages/Tappay'),
    Payme: () => import(/* webpackChunkName: "Payme" */'@/pages/Payme'),
    Wechat: () => import(/* webpackChunkName: "Wechat" */'@/pages/Wechat'),
    Va: () => import(/* webpackChunkName: "Va" */ '@/pages/VirtualAccount'),
    Ovo: () => import(/* webpackChunkName: "Ovo" */ '@/pages/Ovo')
  },
  created () {
    const { payToken, component = 'PaymentSelectList', type, hlang, msg = '', out_trade_no: trandeNo, bindingCard } = getSearchParams()
    this.payToken = payToken
    setLocale(hlang)
    this.$i18n.locale = hlang
    this.setSa()
    if (type === 'unknown' && component === 'Result' && bindingCard !== '1') {
      window.name = sessionStorage.getItem('windowDotName')
      return this.queryPay()
    } else {
      sessionStorage.setItem(nameKey, window.name)
    }
    getRegionInfo().then(res => {
      setCurrencyInfo(res.map(item => item.currency))
    })

    // if (component === 'Result') {
    //   this.queryPay()
    //   return
    // }
    // 2c2p取消逻辑
    if (msg.includes('cancelled') && trandeNo) {
      return this.handleGoTo({ component: 'Result', type: 'failure' })
    }
    this.handleGoTo({ component })
    // 窗口大小改变设置窗口高度
    window.onresize = this.handleWindowResize
  },
  data () {
    return {
      type: 'failure',
      payToken: '',
      isWalletPayment: false,
      payChannelID: '',
      payUrl: '',
      innerHeight: window.innerHeight
    }
  },
  methods: {
    handleWindowResize () {
      this.innerHeight = window.innerHeight
    },
    handleGoTo ({ component = 'PaymentSelectList', type = 'unknown', payChannelID = '', payUrl = '', ...rest } = {}) {
      // this.currentComponent = component
      this.type = type
      // todo 改造所有地方
      this.$store.commit(types.SET_COMPONENT_STATUS, { component, type, ...rest })
      this.payChannelID = payChannelID
      this.payUrl = payUrl
    },
    queryPay () {
      this.$Spin.show()
      queryPay({ payToken: this.payToken }).then(({ data, hlang }) => {
        this.$i18n.locale = hlang
        if (parseInt(data?.status) === 2) {
          this.handleGoTo({ component: 'Result', type: 'success' })
          postMessage({ action: 'cashierOff', status: 2 })
          postMessage({ action: 'cashierOffSelf', status: 2 })
        } else {
          this.handleGoTo({ component: 'Result', type: 'unknown' })
        }
      }).finally(() => {
        this.$Spin.hide()
      })
    },
    paymentTypeChanged (isWalletPayment) {
      this.isWalletPayment = isWalletPayment
    },
    setSa () {
      sa.init({
        server_url: saUrl,
        heatmap: {
          // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
          clickmap: 'not_collect',
          // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
          scroll_notice_map: 'not_collect'
        }
      })
      sa.registerPage({
        platform_type: 'web_desktop',
        data_center: country2DCString(process.env.VUE_APP_BILLD_COUNTRY),
        country: (getLocale() || '').split('_')[1],
        language: getLocale(),
        llm_source: 'web_desktop',
        trigger_time: new Date().toISOString()
      })
    }
  },
  computed: {
    ...mapGetters([types.COMPONENT_STATUS]),
    currentComponent () {
      return this[types.COMPONENT_STATUS].component
    }
  }
}
</script>

<style lang="scss">
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
  overflow: auto;
  background: #fff;
  .fade-transform-leave-active,
  .fade-transform-enter-active {
    transition: all .5s;
  }

  .fade-transform-enter {
    opacity: 0;
    transform: translateX(-30px);
  }

  .fade-transform-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }
}
</style>
